// extracted by mini-css-extract-plugin
export var container = "SliceContainer-module--container--hie4a";